/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do componente Wrap
 */
export const Wrap = styled.div`
 *{
    button{
        font-family: Roboto;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        letter-spacing: 0em;
        text-transform: none;

        display: flex;
        justify-content: space-between;      
        padding: 12px;
        background: white;
        border-radius: 3px;
        color: #5E5E5E;
        margin: 0;
    }
    button:hover {
        background: #FFFFFF;
        border: none;
    }
 }
`;